import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth";

/** Settings shell — sub-tabs for owner-level config: Farms, Users, Profile.
 *  Separated from the operational nav so per-farm pages stay focused and
 *  cross-farm config is grouped in one place. Each sub-route renders in
 *  <Outlet/>. */
export function SettingsShell() {
  const { user } = useAuth();
  const canSeeUsers = user?.role !== "viewer";
  return (
    <>
      <h1 className="page-title">Settings</h1>
      <div className="row" style={{ gap: 4, marginBottom: 20, flexWrap: "wrap" }}>
        <SettingsTab to="/settings/farms">🚜 Farms</SettingsTab>
        {canSeeUsers && <SettingsTab to="/settings/users">👥 Users</SettingsTab>}
        <SettingsTab to="/settings/profile">👤 Profile</SettingsTab>
        <SettingsTab to="/settings/lorawan">📡 LoRaWAN</SettingsTab>
      </div>
      <Outlet />
    </>
  );
}

function SettingsTab({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink to={to} end>
      {({ isActive }) => (
        <span
          style={{
            padding: "6px 14px",
            fontSize: "0.9rem",
            borderRadius: 6,
            border: "1px solid " + (isActive ? "var(--primary)" : "var(--border)"),
            background: isActive ? "var(--primary)" : "var(--surface)",
            color: isActive ? "white" : "var(--text)",
            fontWeight: isActive ? 500 : 400,
          }}
        >
          {children}
        </span>
      )}
    </NavLink>
  );
}
